module.exports = __webpack_public_path__ + "static/media/accent-style.31305bdb.png";